import { useState, useCallback } from "react";

const useConfirmation = () => {
  const [confirmationState, setConfirmationState] = useState({
    open: false,
    title: "",
    message: "",
    confirmText: "Confirm",
    cancelText: "Cancel",
    confirmColor: "error",
    onConfirmCallback: null,
    loading: false,
  });

  const showConfirmation = useCallback(
    ({
      title = "Confirm Action",
      message = "Are you sure you want to proceed?",
      confirmText = "Confirm",
      cancelText = "Cancel",
      confirmColor = "error",
    }) => {
      return new Promise((resolve) => {
        setConfirmationState({
          open: true,
          title,
          message,
          confirmText,
          cancelText,
          confirmColor,
          onConfirmCallback: resolve,
          loading: false,
        });
      });
    },
    []
  );

  const handleConfirm = useCallback(() => {
    if (confirmationState.onConfirmCallback) {
      confirmationState.onConfirmCallback(true);
      setConfirmationState({
        open: false,
        title: "",
        message: "",
        confirmText: "Confirm",
        cancelText: "Cancel",
        confirmColor: "error",
        onConfirmCallback: null,
        loading: false,
      });
    }
  }, [confirmationState.onConfirmCallback]);

  const handleClose = useCallback(() => {
    if (!confirmationState.loading && confirmationState.onConfirmCallback) {
      confirmationState.onConfirmCallback(false);
      setConfirmationState({
        open: false,
        title: "",
        message: "",
        confirmText: "Confirm",
        cancelText: "Cancel",
        confirmColor: "error",
        onConfirmCallback: null,
        loading: false,
      });
    }
  }, [confirmationState.loading, confirmationState.onConfirmCallback]);

  return {
    confirmationState,
    showConfirmation,
    handleConfirm,
    handleClose,
  };
};

export default useConfirmation;

